/**
 * Makes a working-surface Dialog user-resizable via native CSS `resize`.
 *
 * Apply as `PaperProps={{ sx: RESIZABLE_DIALOG_PAPER }}` and keep the Dialog's
 * existing `maxWidth`/`fullWidth` so default sizing does not move. Growth is
 * bounded by those props; shrinking is free.
 *
 * Confirmations and short prompts deliberately do not use this.
 */
export const RESIZABLE_DIALOG_PAPER = {
  resize: 'both',
  // `resize` is inert unless overflow is not visible.
  overflow: 'auto',
  minWidth: 360,
  minHeight: 240,
} as const
